import {QMAP, QMAPService, ServerModel} from 'ng-qmap'
import { Injectable } from "@angular/core"
import { FourDService } from "4d-mapper"
import { Observable } from "rxjs"
import { map } from 'rxjs/operators'

@Injectable()
export class VasatQMAPService extends QMAPService{
    constructor(private fourD:FourDService){
        super()
    }
    objectTypeQMap(objString:string):QMAP[]{
        return [{id:'name',type:'shorttext',title:'Name',required:true}]
    }
    objectsForQMap(qMap:QMAP,searchString?:string,superModel?:any):Observable<ServerModel[]>{
        var query = this.fourD.V.searchByObject(this.fourD.V.registeredClassForString(qMap.obj_type))
        if(searchString)
            query = query.contains('name',searchString)

        return query.queryObservable().pipe(
            map(i => i.items)
        )
    }
    isModel(obj:any):boolean{
        return !!obj && obj.toJSON
    }
    findCachedModel(qmap:QMAP,id:number):ServerModel{
        return this.fourD.V.findCached(qmap.obj_type,id)
    }
    makeModel(qmap:QMAP):ServerModel{
        var clazz = this.fourD.V.registeredClassForString(qmap.obj_type)
        return new clazz(this.fourD.V)
    }
    canWrite(sm:ServerModel):boolean{
        return sm.permissions?sm.permissions.find(p => 'api_update'):true
    }
    canDelete(sm:ServerModel):boolean{
        return sm.permissions?sm.permissions.find(p => 'api_delete'):false
    }
    absURL(m:ServerModel,s:string){
        return m.file(s) + '?access_token=' + this.fourD.V.token
    }
}
